import React, {Component} from 'react'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import './pdf.scss'
import EventBus from '../common/EventBus.js'
import $ from 'jquery'
import ProposalContent from "./content.component.jsx";

class ProposalWord extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            content: '#',
            proposal: null,
            options: [],
            showApprovedMessage: false,
        }
    }

    componentDidMount() {
        AppContext.getApiClient().get('/proposals/' + this.props.match.params.hash).then(res => {
            EventBus.dispatch(EventBus.TopicLocaleChange, {
                locale: res.attributes.variables.global.language,
            })
            this.setState({
                proposal: res.attributes.variables
            })
        })
    }


    render() {
        if (!this.state.proposal) {
            return <LoadingSpinner marginTop="20px" />
        }
        var showBranding=this.state.proposal.global.hasBranding
        $('body').css('background-color', this.state.proposal.global.backgroundColor)
        return <div>
            <div id={'pdf-document'} className="container-fluid pdf-document" style={{width:'100%', margin: '0', padding: '0'}}>
                <ProposalContent showBranding={showBranding} variables={this.state.proposal} editable={false} isWord={true} />
            </div>
        </div>
    }

}

export default ProposalWord





// WEBPACK FOOTER //
// ./src/proposal/word.component.jsx